var _defs, _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgErrorIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "errorIcon_svg__a",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#B81D7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#D6385E"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "url(#errorIcon_svg__a)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 7l.5 2 3 3-3 3-.5 2 2-.5 3-3 3 3 2 .5-.5-2-3-3 3-3 .5-2-2 .5-3 3-3-3L7 7z",
    fill: "#fff"
  })));
}

export default SvgErrorIcon;